// extracted by mini-css-extract-plugin
export default {"goodsContainer":"index_goodsContainer_1n2vj"};